var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"ma-0",staticStyle:{"background-color":"#F4F7F9","height":"100vh"},attrs:{"id":"dag"}}),_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-icon',_vm._g({attrs:{"id":"cauasl_graph_guide"}},on),[_vm._v(" mdi-information-outline ")])]}}])},[_vm._v(" Show tour guide ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }